module.exports = __webpack_public_path__ + "static/media/vencimiento_verde.2c4fb03e.svg";